export enum CartPhase {
    DETAIL = 'detail',
    SHIPPING_AND_PAYMENT = 'shipping_and_payment',
    DELIVERY = 'delivery',
    SUMMARY = 'summary',
}
